import React, { useEffect, useState } from 'react'
import { leaV3API } from '../api/leaV3.api'

export const ActivityView: React.FC = () => {
  const [note, setNote] = useState<string | undefined>()
  const [rows, setRows] = useState<unknown[]>([])

  useEffect(() => {
    leaV3API.getActivity().then((r) => {
      setRows(r.data)
      setNote(r.note)
    })
  }, [])

  return (
    <div className="space-y-4">
      <div className="bg-yellow-50 border border-yellow-300 text-yellow-800 px-4 py-3 rounded">
        <div className="font-semibold mb-1">Scheduler activity log</div>
        <div className="text-sm">
          Cette vue affichera en direct les décisions du scheduler (route matched, no_route, already_handled).
          La table <code className="bg-yellow-100 px-1 rounded">lea_v3.discovery_log</code> n'existe pas encore.
        </div>
        {note && <div className="text-xs text-yellow-700 mt-2 italic">{note}</div>}
      </div>

      {rows.length > 0 && (
        <pre className="bg-gray-50 border border-gray-200 p-3 rounded text-xs overflow-auto">
          {JSON.stringify(rows, null, 2)}
        </pre>
      )}
    </div>
  )
}
